const parseLocation = (location) => {
  switch (location) {
    case 'ENVIRONMENT':
      return 'Ambiente';
    case 'REFRIGERATOR':
      return 'Geladeira';
    default:
      return '';
  }
};

export { parseLocation };
